export const UseCases = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm'
};
export const useCasesQueryParamKey = 'useCases';